import { useState } from 'react';
import { downloadFile } from '../api';
import { useToast, useRole } from './shared';

const thisMonth = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Cairo' }).slice(0, 7);

// "📄 PDF" on the letterhead. kind: 'visit' (id = visit id) | 'month' (id = contract id, with a month picker)
export default function PdfReport({ kind, id, defaultMonth }) {
  const role = useRole();
  const canPrices = role !== 'technician';
  const [prices, setPrices] = useState(canPrices);
  const [month, setMonth] = useState(defaultMonth || thisMonth());
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  async function go() {
    setBusy(true);
    const q = new URLSearchParams({ prices: prices && canPrices ? '1' : '0', ...(kind === 'month' ? { month } : {}) });
    const url = kind === 'visit' ? `/api/pm/visits/${id}/report.pdf?${q}` : `/api/pm/contracts/${id}/report.pdf?${q}`;
    try { await downloadFile(url); } catch (e) { toast(e.message, 'error'); } finally { setBusy(false); }
  }

  return (
    <span className="flex items-center gap-8" style={{ flexWrap: 'wrap' }}>
      {kind === 'month' && <input type="month" className="input" style={{ width: 150, padding: '5px 8px' }} value={month} onChange={e => setMonth(e.target.value)} />}
      <button className="btn btn-ghost btn-sm" onClick={go} disabled={busy}>{busy ? '...' : kind === 'visit' ? '📄 تقرير الزيارة PDF' : '📄 التقرير الشهري PDF'}</button>
      {canPrices && <label className="text-xs text-muted flex items-center" style={{ cursor: 'pointer', gap: 4 }}>
        <input type="checkbox" checked={prices} onChange={e => setPrices(e.target.checked)} />بالأسعار</label>}
    </span>
  );
}
